export const IMPORT_PURGE_TYPE = {
  ISSUED_CHECK_FILES: 0,
  OUTSTANDING_ISSUED_CHECKS: 1,
  ALL_TRANSACTION_HISTORY: 2,
}

export const purgeTypeOptions = [
  {
    label: 'PurgeTransactions:purgeTypeOptions.issuedCheckFiles',
    value: IMPORT_PURGE_TYPE.ISSUED_CHECK_FILES,
    info: 'PurgeTransactions:purgeInfoOptions.issuedCheckFiles',
  },
  // {
  //   label: 'PurgeTransactions:purgeTypeOptions.outstandingIssuedChecks',
  //   value: IMPORT_PURGE_TYPE.OUTSTANDING_ISSUED_CHECKS,
  //   info: 'PurgeTransactions:purgeInfoOptions.outstandingIssuedChecks',
  // },
  // {
  //   label: 'PurgeTransactions:purgeTypeOptions.allTransactionHistory',
  //   value: IMPORT_PURGE_TYPE.ALL_TRANSACTION_HISTORY,
  //   info: 'PurgeTransactions:purgeInfoOptions.allTransactionHistory',
  // },
]

export const DEFAULT_ALL_ACCOUNTS = {
  label: 'PurgeTransactions:defaultAllAccount',
  value: 'all',
}

export const DATE_TIME_FILE_UPLOAD_MOCK = [
  {
    label: '08/19/2024 12:06 AM',
    value: '42f9cd67-975d-48df-ae78-3382286a9544',
    dateUpload: '08/19/2024 12:06 AM',
    dateProcessed: '08/19/2024 12:06 AM',
    fileName: 'file1.xlsx',
    numberOfRecordsToDelete: 10,
    totalAmountForRecordsToDelete: 100,
  },
  {
    label: '08/21/2024 2:06 AM',
    value: '42f9cd67-975d-48df-as78-3382286a2544',
    dataUpload: '08/21/2024 2:01 AM',
    dateProcessed: '08/21/2024 2:06 AM',
    fileName: 'file2.xlsx',
    numberOfRecordsToDelete: 20,
    totalAmountForRecordsToDelete: 200,
  },
  {
    label: '08/22/2024 1:06 PM',
    value: '4aaacd67-975d-48df-as78-3382286a2544',
    dateUpload: '08/22/2024 1:06 PM',
    dateProcessed: '08/22/2024 1:06 PM',
    fileName: 'file3.xlsx',
    numberOfRecordsToDelete: 30,
    totalAmountForRecordsToDelete: 300,
  },
]

export const DATE_TIME_PURGE_PRIOR_MOCK = [
  {
    label: '08/19/2024 12:06 AM 213123',
    value: '42f9cd67-975d-48df-ae78-3382286a9544',
  },
  // {
  //   label: '08/21/2024 2:06 AM 12312321',
  //   value: '42f9cd67-975d-48df-as78-3382286a2544',
  // },
  {
    label: '08/22/2024 1:06 PM 1231321',
    value: '4aaacd67-975d-48df-as78-3382286a2544',
  },
]
